var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.505 13V0.609999H4.285C6.9625 0.609999 8.7125 1.6425 8.7125 4.0575C8.7125 6.5425 6.77 7.5575 4.1975 7.5575H2.2375V13H0.505ZM2.2375 2.08V6.0875H4.075C5.7725 6.0875 6.9625 5.5275 6.9625 4.0575C6.9625 2.57 5.7375 2.08 4.11 2.08H2.2375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP);
export default __webpack_public_path__ + "static/media/P.173c99c3307cdf1198540e1df897b73d.svg";
export { ForwardRef as ReactComponent };